import React, { Component } from 'react';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import Header from '../../components/Header/Header';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import CancelUrl, { COMPONENT_STYLE } from '../../../US/components/CancelUrl/CancelUrl';
import '../../styles/base-us.less';
import Col from '../../../shared-components/VXGrid/Col';
import Row from '../../../shared-components/VXGrid/Row';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';
import setUrl from '../../../framework/App/SetUrl';
import './InvalidNamePage.less';
import { get } from 'lodash';

const LOCALE_PREFIX = 'US/pages/InvalidNamePage/InvalidNamePage';
const UPDATE_NAME_LINK = 'https://www.paypal.com/myaccount/settings/name/edit';

export class InvalidNamePage extends Component {
    static propTypes = {
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        updateNameUrl: PropTypes.string,
        intl: intlShape.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        handleUpdateName: PropTypes.func.isRequired,
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        const { intl, flow, handleUpdateName, updateNameUrl } = this.props;
        const messageHeader = intl.formatMessage({ id: `${LOCALE_PREFIX}.headerMessage` });
        const messagePara = intl.formatMessage({ id: `${LOCALE_PREFIX}.messagePara` });
        const updateText = intl.formatMessage({ id: `${LOCALE_PREFIX}.updateText` });

        return (
            <div>
                <div className="outerWrapper us-wrapper">
                    <div id="wrapper">
                        <div id="main">
                            <div id="InvalidNamePage">
                                <Header singleColumnLayout={true} displayLogout={(flow === FLOW_TYPE.DIRECT_APP)} />
                                <section id="invalidName" className="contentSection">
                                    <Row fluid={true} className="container" id="declined">
                                        <Col xs={12}>
                                            <div className="invalid-name-content">
                                                <span className="vx_icon vx_icon-large vx_icon-attention-large" />
                                                <h1 className="vx_text-2">{messageHeader}</h1>
                                                <p>{messagePara}</p>
                                            </div>
                                            <Row>
                                                <Col sm={8} smOffset={2}>
                                                    <div className="buttons">
                                                        <Button
                                                            data-automation-id="updateName"
                                                            btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                                            onClick={() => handleUpdateName(updateNameUrl)}
                                                            id="updateName"
                                                        >
                                                            {updateText}
                                                        </Button>
                                                        <CancelUrl
                                                            id="updateNameCancel"
                                                            componentType={COMPONENT_STYLE.LINK_BUTTON}
                                                            fptiEvent={{
                                                                stateName: 'pp_credit_updatenamepage',
                                                                transitionName: 'cancel_pp_credit_updatenamepage'
                                                            }}
                                                            customLabel={`${LOCALE_PREFIX}.cancelApplication`}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    flow: state.serverData.flow,
    updateNameUrl: get(state, 'serverData.updateNameUrl', false),
});

export const mapDispatchToProps = dispatch => ({
    fireFptiEvent(stateName, transitionName) {
        dispatch(trackTransition(stateName, transitionName));
    },
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_updatenamepage', 'prepare_pp_credit_updatenamepage'));
    },
    handleUpdateName(updateLink) {
        const updateNameUrl = updateLink || UPDATE_NAME_LINK;
        dispatch(trackTransition('pp_credit_updatenamepage', 'update_name_pp_credit_updatenamepage'));
        setUrl(window, updateNameUrl);
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(InvalidNamePage));
